
export class TagModel {
  Tag: string;
  Matricula: string;
  public UltFechaVolum?: string;
}
